<template>

  <q-toolbar class="bg-grey-2">
    <q-toolbar-title class="text-100 text-bold">Pricing Details</q-toolbar-title>
  </q-toolbar>

  <q-card flat>

    <historical-usage-selector v-if="show_historical_usage" v-model="selected_usage"
                               :plan="plan"></historical-usage-selector>

    <single-usage-selector :plan="plan" v-model="selected_usage" v-else></single-usage-selector>

    <q-list>
      <q-expansion-item header-class="text-100 text-primary" v-model="show_calcs" icon="calculate" expand-separator
                        :label="show_calcs ? 'Hide Detailed Calculations' : 'Show Detailed Calculations'">
        <pricing-calcs :plan="plan" :usage="selected_usage"></pricing-calcs>
      </q-expansion-item>
      <q-separator></q-separator>
      <q-expansion-item class="gt-xs" header-class="text-100 text-primary" v-model="show_chart" icon="insights" expand-separator
                        :label="show_chart ? 'Hide Usage-Based Pricing Chart' : 'Show Usage-Based Pricing Chart'">
        <plan-chart :plan="plan"></plan-chart>
      </q-expansion-item>
    </q-list>

  </q-card>
</template>

<script>
import { onBeforeMount, ref, watch } from "vue";
import PricingCalcs from "components/plans/cards/PricingCalcs";
import UsageFilters from "src/composables/UsageFilters";
import SingleUsageSelector from "components/plans/cards/SingleUsageSelector";
import HistoricalUsageSelector from "components/plans/cards/HistoricalUsageSelector";
import PlanChart from "components/plans/cards/PlanChart";

export default {
  name: "PricingDetails",
  components: { PlanChart, HistoricalUsageSelector, SingleUsageSelector, PricingCalcs },
  props: {
    plan: {
      type: Object,
      required: true
    }
  },
  setup() {
    const { usage_selected, show_historical_usage, historical_usage } = UsageFilters();
    const selected_usage = ref(500);
    const show_calcs = ref(false);
    const show_chart = ref(false);

    onBeforeMount(() => {
      if (show_historical_usage.value) {
        selected_usage.value = historical_usage.value.find(x => x.usage)?.usage;
      }
      else {
        selected_usage.value = usage_selected.value
      }

      watch(selected_usage, () => {
        show_calcs.value = true;
      })
    })

    return {
      show_calcs,
      show_chart,
      selected_usage,
      show_historical_usage
    }
  }
}
</script>

<style>

</style>
